import { gsap } from 'gsap';
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText);

class RaiserLetters {
    constructor() {

        this.DOM = { $raiserElems: [...document.querySelectorAll('.raiser-letters')] }

        this.split = new SplitText(this.DOM.$raiserElems, { type: "chars", charsClass: "raiserChars" })

        this.fireOnce = true;
        this.observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                const letters = document.querySelectorAll('.raiserChars')
                if (entry.isIntersecting) {
                    gsap.from(letters, {
                        y: 75,
                        opacity: 0,
                        duration: .75,
                        stagger: .05,
                        ease: "back.out(5)"
                    })
                    if (this.fireOnce) this.observer.unobserve(entry.target)
                }
            });
        }, {
        });
        this.init()
    }
    init() {
        this.initObervation()
    }

    initObervation() {
        this.DOM.$raiserElems.forEach(elem => this.observer.observe(elem))
    }

}

export { RaiserLetters }

